<!-- Auto-Fill Smart Cart Banner -->
<div class="auto-fill-smart-cart">
    <!-- Not Configured State - Shows Feature Banner -->
    <div class="smart-cart-wrapper"
        *ngIf="!isConfigured && !isLoading">
        <div class="smart-cart-banner">
            <div class="banner-content">
                <div class="banner-icon">
                    <img src="assets/images/smart-cart-icon.png"
                        alt="Auto-Fill Smart Cart"
                        class="smart-cart-img-icon">
                </div>
                <div class="banner-text">
                    <div class="banner-title">
                        <span>Auto-Fill Smart Cart</span>
                        <span class="new-badge">NEW FEATURE</span>
                    </div>
                    <p class="banner-description">Lowest price across all suppliers, added automatically.</p>
                </div>
            </div>
            <button class="configure-btn"
                (click)="openConfigureModal()">
                Configure Now
            </button>
        </div>

        <!-- Info Footer (Inside the wrapper) -->
        <div class="info-footer">
            <div class="info-content">
                <i class="material-icons">info_outline</i>
                <span>Default: Auto-Fill Cart will done from all suppliers for the best rate.</span>
            </div>
        </div>
    </div>

    <!-- Configured State - Shows Status Bar -->
    <div class="smart-cart-status"
        *ngIf="isConfigured && !isLoading">
        <div class="status-indicator">
            <span class="status-dot"></span>
            <span class="status-label">AUTO-FILL SMART CART</span>
            <button class="info-btn"
                title="Auto-fill smart cart info">
                <i class="material-icons">info_outline</i>
            </button>
        </div>
        <div class="status-value">
            <span class="preferred-label">Preferred:</span>
            <span class="preferred-suppliers">{{ configDisplayText }}</span>
        </div>
        <button class="modify-btn"
            (click)="openModifySettings()">
            <i class="material-icons">edit</i>
            Modify Setting
        </button>
    </div>

    <!-- Loading State -->
    <div class="loading-state"
        *ngIf="isLoading">
        <div class="spinner"></div>
        <span>Loading configuration...</span>
    </div>
</div>

<!-- Setup Modal -->
<div class="modal-overlay"
    *ngIf="isModalOpen"
    (click)="closeModal()">
    <div class="modal-container"
        (click)="$event.stopPropagation()">

        <!-- Step 1: How It Works -->
        <div class="modal-content step-1"
            *ngIf="currentStep === SetupStep.INTRO">
            <div class="modal-header">
                <div class="step-badge">STEP 1 • HOW IT WORKS?</div>
                <button class="close-btn"
                    (click)="closeModal()">
                    <i class="material-icons">close</i>
                </button>
            </div>

            <h2 class="modal-title">Auto-Fill Smart Cart</h2>

            <div class="steps-list">
                <div class="step-item">
                    <div class="step-icon search">
                        <i class="material-icons">search</i>
                    </div>
                    <div class="step-content">
                        <h4>Search Items</h4>
                        <p>Search for items across your connected suppliers</p>
                    </div>
                </div>

                <div class="step-item">
                    <div class="step-icon compare">
                        <svg width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 12H20M4 12L8 8M4 12L8 16M20 12L16 8M20 12L16 16"
                                stroke="#D4A012"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="step-content">
                        <h4>Compare Prices</h4>
                        <p>Compare prices of same item across multiple suppliers</p>
                    </div>
                </div>

                <div class="step-item">
                    <div class="step-icon cart">
                        <svg width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 6H20L18 14H8L6 6Z"
                                stroke="#D4A012"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M6 6L4 2H2"
                                stroke="#D4A012"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <circle cx="9"
                                cy="19"
                                r="2"
                                stroke="#D4A012"
                                stroke-width="2" />
                            <circle cx="17"
                                cy="19"
                                r="2"
                                stroke="#D4A012"
                                stroke-width="2" />
                        </svg>
                    </div>
                    <div class="step-content">
                        <h4>Auto-Fill Cart</h4>
                        <p>Lowest price from your chosen suppliers, added automatically to cart</p>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn-secondary"
                    (click)="closeModal()">Cancel</button>
                <button class="btn-primary"
                    (click)="continueToSetup()">Continue to Setup</button>
            </div>
        </div>

        <!-- Step 2: Select Preferred Suppliers -->
        <div class="modal-content step-2"
            *ngIf="currentStep === SetupStep.CONFIGURE">
            <div class="modal-header">
                <div class="step-badge step-2-badge">STEP 2 OF 2</div>
                <button class="close-btn"
                    (click)="closeModal()">
                    <i class="material-icons">close</i>
                </button>
            </div>

            <h2 class="modal-title">Select Preferred Suppliers</h2>
            <p class="modal-subtitle">By default, we compare all suppliers for the lowest price. Uncheck to skip any.
            </p>

            <div class="supplier-section">
                <div class="section-header">
                    <span class="section-title">Choose & Sort Suppliers</span>
                    <span class="section-hint">
                        <i class="material-icons">drag_indicator</i>
                        Drag to Sort
                    </span>
                </div>
                <p class="section-description">Selection order affects search results on discovery</p>

                <div class="supplier-list"
                    cdkDropList
                    (cdkDropListDropped)="onSupplierDrop($event)">
                    <div class="supplier-item"
                        *ngFor="let supplier of tempSupplierPreferences; let i = index"
                        cdkDrag
                        [class.disabled]="!supplier.autoFill">
                        <div class="drag-area"
                            cdkDragHandle>
                            <div class="drag-handle">
                                <i class="material-icons">drag_indicator</i>
                            </div>
                            <span class="supplier-name">{{ supplier.name }}</span>
                        </div>
                        <label class="checkbox-container"
                            (mousedown)="$event.stopPropagation()"
                            (touchstart)="$event.stopPropagation()">
                            <input type="checkbox"
                                [checked]="supplier.autoFill"
                                (change)="toggleSupplier(supplier)">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn-secondary"
                    (click)="closeModal()">Cancel</button>
                <button class="btn-primary"
                    (click)="finishSetup()"
                    [disabled]="!hasEnabledSuppliers || isSaving">
                    <span *ngIf="!isSaving">Finish Setup</span>
                    <span *ngIf="isSaving">Saving...</span>
                </button>
            </div>
        </div>

    </div>
</div>